


const Banner = () => (
    <section id="banner" className="major">

        <div className="inner">
            <header className="major">
                <h1>Bok &#128047;, jesi li za igru u džungli?</h1>

            </header>
            <div className="content">
            <p>Dječja rođendaonica pod nazivom "Džungla" predstavlja maštovit i veselo uređen prostor
                    koji je osmišljen kako bi pružio nezaboravno iskustvo svakom djetetu na njihovom posebnom danu.</p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">Započni avanturu</a></li>
                </ul>
            </div>
        </div>
    </section>
);


export default Banner;